<template>
  <section data-test="filter-person-section">
    <h4 class="text-base font-normal leading-none text-theme-33">
      เลขบัตรประชาชน
    </h4>
    <input
      class="form-control form-control-sm mt-2"
      type="text"
      placeholder="กรุณากรอกเลขบัตรประชาชน"
      :value="national_id"
      @input="handelNationalIdChange"
    >
    <h4 class="text-base font-normal leading-none text-theme-33 mt-3">
      ชื่อ-นามสกุล
    </h4>
    <input
      class="form-control form-control-sm mt-2"
      type="text"
      placeholder="กรุณากรอกชื่อ-นามสกุล"
      :value="full_name"
      @input="handelFullNameChange"
    >
  </section>
</template>

<script setup>
const props = defineProps({
  national_id: String,
  full_name: String,
});

const emits = defineEmits(["update:national_id", "update:full_name"]);

const handelNationalIdChange = (evt) => {
  emits("update:national_id", evt.target.value);
};
const handelFullNameChange = (evt) => {
  emits("update:full_name", evt.target.value);
};
</script>
